// frontend/src/pages/Terms.jsx
// This component renders a minimal Terms and Conditions page with increased top spacing
import { useEffect } from "react";
import HeaderSimple from "../components/pages/home/HeaderSimple";
import Footer from "../components/pages/home/Footer";
import { updatePageTitle } from "../utils/titleUtils";

// This is the main terms and conditions page component
const Terms = () => {
  // This sets the browser tab title and scrolls to top when the page loads
  useEffect(() => {
    updatePageTitle("Terms and Conditions");
    window.scrollTo(0, 0);
  }, []);

  // This returns minimal layout without containers, borders or shadows
  return (
    <div className="min-h-screen bg-bg-60">
      {/* This shows the simple header at the top */}
      <HeaderSimple />

      {/* This is the main content with top margin and simple typography */}
      <main className="pt-48 pb-20 px-6">
        {/* This wraps the content to a max width similar to the home page */}
        <div className="w-[90%] max-w-5xl mx-auto">
          {/* This is the page title and effective date centered only */}
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-fg-50 mb-2">Terms and Conditions</h1>
            <p className="text-fg-60">Effective date: November 15, 2025</p>
          </div>

          {/* This section explains acceptance of terms */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Acceptance of Terms</h2>
            <p className="text-fg-60">
              By accessing or using the service, you agree to these Terms and our Privacy and Cookies Policies. If you do not
              agree, you may not use the service.
            </p>
          </section>

          {/* This section explains accounts and eligibility */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Accounts and Eligibility</h2>
            <p className="text-fg-60">
              You must provide accurate information and maintain the security of your account. Organization members must
              comply with applicable policies set by their administrators.
            </p>
          </section>

          {/* This section explains acceptable use */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Acceptable Use</h2>
            <p className="text-fg-60">
              Do not misuse the service, attempt to bypass controls, or use it for unlawful purposes. Respect intellectual
              property, privacy, and security norms when interacting with external model providers.
            </p>
          </section>

          {/* This section explains content and ownership */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Content and Ownership</h2>
            <p className="text-fg-60">
              You retain rights in your content. We may process your prompts and context to deliver features. Providers that
              you select may process data under their own policies.
            </p>
          </section>

          {/* This section explains disclaimers and liability */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Disclaimers and Liability</h2>
            <p className="text-fg-60">
              The service is provided "as is" without warranties. To the maximum extent allowed by law, liability is limited
              for indirect or consequential damages.
            </p>
          </section>

          {/* This section explains termination and changes */}
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Termination and Changes</h2>
            <p className="text-fg-60">
              We may suspend or terminate access if you violate these Terms. We may update these Terms; continued use means
              acceptance of the changes.
            </p>
          </section>

          {/* This section explains contact information */}
          <section>
            <h2 className="text-2xl font-semibold text-fg-50 mb-3">Contact</h2>
            <p className="text-fg-60">
              If you have questions about these Terms, contact us at
              <span className="font-medium"> abc@Leebai.com</span>.
            </p>
          </section>
        </div>
      </main>

      {/* This shows the global footer at the bottom */}
      <Footer />
    </div>
  );
};

export default Terms;